import React, { memo } from "react";
import FormField from "../Common/FormField";

const AuthorizedSignatoryNameField = memo(({ name, id, t, fullName, onNameChange, getError }) => (
  <FormField
    id={name}
    name={name}
    label={t(`newuser.${id}`)}
    colmd="col-md-6"
    value={fullName[name]}
    onChange={(event) => onNameChange(name, event.target.value)}
    onBlur={(event) => onNameChange(name, event.target.value)}
    error={getError(name, id)} />
));

export default AuthorizedSignatoryNameField;
